import {ISetHighlightedElementTabAction, ISetSidePanelContentAction, ISwitchGridAction, SidePanelContent} from './types/grid.types';

export const SWITCH_GRID = 'SWITCH_GRID';
export const SET_SIDE_PANEL_CONTENT = 'SET_SIDE_PANEL_CONTENT';
export const SET_HIGHLIGHTED_ELEMENT_TAB = 'SET_HIGHLIGHTED_ELEMENT_TAB';

export const switchGridAction = (): ISwitchGridAction => ({
    type: SWITCH_GRID,
});

export const setSidePanelContentAction = (content: SidePanelContent): ISetSidePanelContentAction => ({
    type: SET_SIDE_PANEL_CONTENT,
    content,
});

export const setHighlightedElementTabAction = (tab: string | null): ISetHighlightedElementTabAction => ({
    type: SET_HIGHLIGHTED_ELEMENT_TAB,
    tab,
});
